import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { v4 as uuidv4 } from 'uuid';
@Component({
  selector: 'app-toggle-filter',
  templateUrl: './toggle-filter.component.html',
  styleUrls: ['./toggle-filter.component.scss'],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatIconModule],
})
export class ToggleFilterComponent implements OnInit {
  @Input() option1: string = '';
  @Input() option1Icon: string = '';
  @Input() option2: string = '';
  @Input() option2Icon: string = '';
  @Input() control: FormControl;
  id: string = '';

  constructor() {}

  ngOnInit() {
    this.id = uuidv4();
  }
}
